<template>
  <div class="md:w-full md:flex md:justify-center bg-white">
    <div class="bg-white rounded-t-xxl md:flex md:w-11/12"
    :style="hasKiosk && mainSectionTopRadius "
    >
      <div v-if="!menu.desktop_kiosk_left_bar" class="rounded-t-xxl"
    :style="hasKiosk && mainSectionTopRadius "
      
      >
        <Category class="block" />
      </div>
      <div v-else class="md:block hidden">
        <TopNavigation
          :desktopMode="
            userAgent.device.type === 'desktop' && !hasKiosk
          "
        />
      </div>
      <div class="md:w-11/12 overflow-scroll h-screen pb-56">
        <div class="mt-8 flex flex-row mx-4">
          <div :class="['flex w-1/2 lg:2/3 justify-begin text-3xl flex-col']">
            <div v-trans:name="selectedMenuCategory"></div>
            <div
              class="text-xs"
              v-trans:description="selectedMenuCategory"
            ></div>
          </div>
          <div class=" w-1/2 lg:1/3 justify-end items-center hidden">
            <Language />
            <!-- <DisplayMode class="ml-2" /> -->
          </div>
        </div>

        <div class="flex content-center flex-wrap">
          <div
            v-for="(menuCategory, index) in menuSubCategories"
            v-bind:key="menuCategory.id"
            :class="[isListDisplayed ? 'w-full' : 'w-1/2']"
            @click="getCategories(menuCategory)"
          >
            <div class="flex justify-between items-center border-b-1.5 px-4">
              <div
                :class="[
                  'cursor-pointer flex justify-center py-6 rounded items-center my-2 rounded-large transition duration-500 flex-1',
                  isListDisplayed
                    ? ''
                    : index % 2 == 0
                    ? 'mr-2 flex-col'
                    : 'ml-2 flex-col',
                ]"
              >
                <div
                  :class="[
                    'flex  w-full flex-col',
                    menuCategory.picture_url ? 'justify-end' : 'justify-center',
                    isListDisplayed ? 'flex-row' : 'flex-col',
                  ]"
                >
                  <div>
                    <div
                      v-if="menuCategory.picture_url"
                      class="w-1/2 justify-center flex items-center"
                    >
                      <div
                        class="h-16 w-24 rounded-lg overflow-hidden flex items-center"
                      >
                        <img
                          v-if="menuCategory.picture_url"
                          :src="
                            'https://res.cloudinary.com/mdware/image/fetch/q_auto,f_auto/' +
                              menuCategory.picture_url
                          "
                          alt
                          class="object-fill rounded-lg"
                        />
                      </div>
                    </div>
                    <div
                      :class="[
                        isListDisplayed
                          ? menuCategory.picture_url
                            ? 'w-1/2'
                            : ''
                          : '',
                        'text-lg',
                      ]"
                      :style="makeStyles(hasKiosk&&titleFont,hasKiosk&&titleTextTransform)"
                      v-trans:name="menuCategory"
                    ></div>
                  </div>
                  <div>
                    <p class="text-sm text-gray-800">
                      {{ menuCategory["description" + "_" + language] }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                class=" bg-primary-100 rounded-full w-8 h-8 flex justify-center"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                  <path
                    d="M242.6 280.3l-103.9 82.2c-5 4-13.1 4-18.2 0l-12.1-9.6c-5-4-5-10.4 0-14.3l82.4-65.5-82.4-65.5c-5-4-5-10.4 0-14.3l12.1-9.6c5-4 13.1-4 18.2 0l103.9 82.2c5 4 5 10.4 0 14.4z"
                    :stroke="buttonImgColors"
                    :fill="buttonImgColors"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import lang from "../lang.js";
import Language from "../views/Language";
// import DisplayMode from "../views/DisplayMode";
import Category from "../views/Category";
import TopNavigation from "../components/TopNaviation.vue";
export default {
  data() {
    return {
      lang: lang,
    };
  },
  components: { /* DisplayMode,*/ Category, Language, TopNavigation },
  computed: {
    ...mapGetters([
      "menuSubCategories",
      "theme",
      "language",
      "isCartViewShown",
      "isListDisplayed",
      "menuCategories",
      "selectedMenuCategory",
      "parentSelectedMenuCategory",
      "isSubSubCategory",
      "userAgent",
      "hasKiosk",
      "menu",
      "categoryId",
      "currentHash",
    ]),
    ...mapGetters(["Theme",
      "buttonImgColors",
      "titleFont", 
      "titleTextTransform", 
      "mainSectionTopRadius"
    ]),
  },
  methods: {
    getCategories(item) {
      this.$store.commit("updateCategoryId", item.Id);
      if (item.hasSubCategories) {
        this.$store.commit(
          "updateSubCategoryId",
          this.$route.params.subCategoryId
        );
        this.$store.dispatch("GET_MENU_SUB_CATEGORIES");
        this.$store.commit("updateMenuCategoriesCategories", item);
        
        this.$router
          .push(
            "/" +
              this.$route.params.menuHash +
              "/category/" +
              this.$route.params.subCategoryId
          )
          .catch(() => {});
      } else {
        this.$store.commit("updateIsCategorySubItem", true);
        this.$store.dispatch("GET_CATEGORY");
        this.$store.commit("updateIsSubSubCategory", true);
       
       /** Add subCategoryId params in route for sub categories */
        this.$router
          .push(
            "/" +
              this.$route.params.menuHash +
              "/sub/"+item.Id+"/category/" +
              this.$route.params.categoryId
          )
          .catch(() => {});
      }
    },
  },
  mounted() {
    if (this.$route.name == "CategoryCategory" &&this.parentSelectedMenuCategory?.Id) {
      this.$store.commit(
        "updateSelectedMenuCategory",
        this.parentSelectedMenuCategory
      );
    }
    if(!this.currentHash){
      this.$store.commit("updateCurrentHash", this.$route.params.menuHash);
      this.$store.commit("updateMenuHash", this.$route.params.menuHash);
    }
    if(!this.categoryId){
      this.$store.commit("updateCategoryId", this.$route.params.categoryId);
    }

    if(!this.parentSelectedMenuCategory?.Id){
      this.$store.dispatch("GET_MENU_ITEMS").then(()=>{
        let menuCategory=this.menuCategories.find(el=>el.Id==this.$route.params.categoryId)
          this.$store.commit("updateParentSelectedMenuCategory", menuCategory)
          this.$store.commit("updateSelectedMenuCategory", menuCategory)
          if(menuCategory?.hasSubCategories){
            this.$store.dispatch("GET_MENU_SUB_CATEGORIES");
            }
      });
    }

  },
};
</script>

<style></style>
